export default __webpack_public_path__ + "static/media/reschedule-group-blue-time.8579b003.svg";